/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  var user = "";
  $on('pageInit', function () {
    user = localStorage.getItem("username");
    $update();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="settings">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="title">Profile</div>
    </div>
  </div>
  <div class="page-content">
    <div class="block-title">User Profile</div>
    <div class="card data-table">
      <table>
        <thead>
          <tr>
            <th class="label-cell">Info</th>
            <th class="numeric-cell">Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="label-cell">User</td>
            <td class="numeric-cell">${user}</td>
          </tr>
        </tbody>
      </table>  
    </div>


  </div>
</div>
`
    }
    ;
}

framework7Component.id = 'f6a2dfe39e';
export default framework7Component;